import { useNCTextLocalizer } from '../../../locale/useNCTextLocalizer';
import { MessageDialog, useMessageDialogText } from '../../MessageDialog';
import { jsx as _jsx } from "react/jsx-runtime";
const InvertAppColorErrorDialog = props => {
  const localizer = useNCTextLocalizer('Settings');
  const {
    CLOSE
  } = useMessageDialogText();
  return /*#__PURE__*/_jsx(MessageDialog, {
    type: "error",
    isOpen: true,
    title: localizer('settings.invertApplicationColorsError.dialog.title'),
    text: localizer('settings.invertApplicationColorsError.error.msg'),
    dismissAction: {
      text: CLOSE,
      onPress: () => props.onClose(),
      isDefault: true
    }
  });
};
export default InvertAppColorErrorDialog;
//# sourceMappingURL=InvertAppColorErrorDialog.js.map